import React, {Component} from 'react';
import Util from '../../forecast-app/shared/util/util';
import {FormattedDate, FormattedMessage, injectIntl} from 'react-intl';
import WarningIcon from '../../images/warning_icon';
import AssignedTableTile from '../../forecast-app/shared/components/table-tiles/assigned_table_tile';
import TdLink from '../../components/td_link';
import LabelsCell from '../../containers/overview/labels_cell';
import StarTask from '../../forecast-app/shared/components/star/star_task';

class UpcomingTasksTable extends Component {
	getPath(task) {
		const newLocation = window.location.pathname;
		return (newLocation.endsWith('/') ? newLocation : newLocation + '/') + 'T' + task.node.companyTaskId;
	}

	render() {
		const {formatMessage, formatNumber} = this.props.intl;
		return (
			<table
				className={'upcoming-list-table' + (this.props.listOverflowWidth !== null && this.props.listOverflowWidth !== undefined ? '' : ' not-overflowing') + (this.props.columns.filter(col => col.checked).length > 8 ? ' use-max-width' : '')}
				ref={el => (this.table = el)}
			>
				<thead>
					<tr>
						{this.props.columns.map((col, index) => {
							return col.checked ? (
								col.name === 'comments/files' ? (
									<th key={index}>
										{formatMessage({id: 'common.files-comments'})}
										<span>&nbsp;&nbsp;</span>
									</th>
								) : (
									<th
										key={index}
										className={'sortable ' + (col.name === 'project' ? 'project-column ' : '') + (this.props.sortBy.column === col.name ? (this.props.sortBy.ascending ? 'ascending' : 'descending') : '')}
										title={col.name === 'id' ? 'ID' : formatMessage({id: col.translationId})}
										ref={el => {
											if (col.name === 'name') {
												this.nameHeader = el;
											} else if (col.name === 'project name') {
												this.projectHeader = el;
											}
										}}
										onClick={this.props.setSortBy.bind(this, col.name)}
									>
										{col.name === 'id' ? 'ID' : formatMessage({id: col.translationId})}
										<span>&nbsp;&nbsp;</span>
									</th>
								)
							) : null;
						})}
					</tr>
				</thead>
				<tbody>
					{this.props.tasks.map(task => {
						return (
							<tr key={task.node.id} className={task.node.favoured ? 'favoured' : ''}>
								{this.props.columns.map((col, index) => {
									if (col.checked) {
										if (col.name === 'project') {
											return (
												<TdLink
													key={index}
													path={`/project/P-${task.node.project.companyProjectId}/`}
													content={
														<div
															style={{
																backgroundColor: task.node.project.projectColor,
																color: Util.getTextColor(task.node.project.projectColor),
															}}
															className={'project-indicator' + (task.node.project.projectColor === '#ffffff' ? ' border' : '')}
														>
															{`P${task.node.project.companyProjectId}`}
														</div>
													}
													className="id-link"
												/>
											);
										} else if (col.name === 'id') {
											return (
												<TdLink
													key={index}
													content={<span className="upcoming-id-column">T{task.node.companyTaskId} </span>}
													path={this.getPath(task)}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
												/>
											);
										} else if (col.name === 'name') {
											const warnings = Util.GetTaskWarnings(task.node, this.props.intl);
											const danger = warnings.filter(warning => warning.color === 'red').length;
											return (
												<TdLink
													key={index}
													path={this.getPath(task)}
													content={
														<div className="warning-name-wrapper apply-max-width">
															{warnings.length !== 0 ? (
																<div className="warning-icon">
																	<WarningIcon danger={danger} customWidth={15} customHeight={15} title={warnings[0].message} />
																</div>
															) : null}
															<span>{task.node.name}</span>
														</div>
													}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													className="task-name-td"
												/>
											);
										} else if (col.name === 'status') {
											return <TdLink key={index} path={this.getPath(task)} content={task.node.statusColumnV2 != null ? task.node.statusColumnV2.name : ''} />;
										} else if (col.name === 'owner') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={
														<AssignedTableTile
															disabled={true}
															hideName={true}
															useTableStyling={true}
															assignablePersons={[]}
															assignableRoles={[]}
															assignedPersons={task.node.owner ? [task.node.owner] : []}
															isMultiSelect={true}
															id={task.node.id}
															key={'assigned'}
															task={task}
															maxDisplayed={1}
															cy={'assigned'}
														/>
													}
												/>
											);
										} else if (col.name === 'start date') {
											return (
												<TdLink
													key={index}
													path={this.getPath(task)}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													content={task.node.startYear ? <FormattedDate value={new Date(task.node.startYear, task.node.startMonth - 1, task.node.startDay)} /> : formatMessage({id: 'card_modal.due_date_not_set'})}
												/>
											);
										} else if (col.name === 'deadline') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={task.node.deadlineYear ? <FormattedDate value={new Date(task.node.deadlineYear, task.node.deadlineMonth - 1, task.node.deadlineDay)} /> : formatMessage({id: 'card_modal.due_date_not_set'})}
												/>
											);
										} else if (col.name === 'remaining') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={
														task.node.project.estimationUnit === 'HOURS' ? (
															Util.convertMinutesToFullHour(task.node.timeLeft, this.props.intl)
														) : (
															<FormattedMessage defaultMessage="{points, number} p" values={{points: task.node.timeLeft}} id="common.x_points" />
														)
													}
												/>
											);
										} else if (col.name === 'project name') {
											return <TdLink key={index} content={task.node.project.name} path={`/project/P-${task.node.project.companyProjectId}/`} className={'project-name-td'} />;
										} else if (col.name === 'comments/files') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={
														<div className="meta">
															<span className="comments">{formatNumber(task.node.commentCount)}</span>
															<span className="files">{formatNumber(task.node.fileCount)}</span>
														</div>
													}
												/>
											);
										} else if (col.name === 'client') {
											return <TdLink key={index} path={this.getPath(task)} content={task.node.project.client ? task.node.project.client.name : ''} showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)} />;
										} else if (col.name === 'low') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={
														task.node.project.estimationUnit === 'HOURS' ? (
															Util.convertMinutesToFullHour(task.node.estimateLow, this.props.intl)
														) : (
															<FormattedMessage defaultMessage="{points, number} p" values={{points: task.node.estimateLow}} id="common.x_points" />
														)
													}
												/>
											);
										} else if (col.name === 'high') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={
														task.node.project.estimationUnit === 'HOURS' ? (
															Util.convertMinutesToFullHour(task.node.estimateHigh, this.props.intl)
														) : (
															<FormattedMessage defaultMessage="{points, number} p" values={{points: task.node.estimateHigh}} id="common.x_points" />
														)
													}
												/>
											);
										} else if (col.name === 'forecast') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={
														task.node.project.estimationUnit === 'HOURS' ? (
															Util.convertMinutesToFullHour(task.node.estimateForecast, this.props.intl)
														) : (
															<FormattedMessage defaultMessage="{points, number} p" values={{points: task.node.estimateForecast}} id="common.x_points" />
														)
													}
												/>
											);
										} else if (col.name === 'time entries') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={Util.convertMinutesToFullHour(
														task.node.timeRegistrations.edges.length !== 0
															? task.node.timeRegistrations.edges.reduce((total, timeReg) => {
																	return total + timeReg.node.minutesRegistered;
															  }, 0)
															: 0,
														this.props.intl
													)}
												/>
											);
										} else if (col.name === 'over forecast') {
											let overForecast;
											if (task.node.project.estimationUnit === 'HOURS') {
												overForecast = (task.node.estimateForecast - task.node.timeRegistrations.edges.reduce((total, timeReg) => total + timeReg.node.minutesRegistered, 0)) * -1;
											} else {
												const time = task.node.timeRegistrations.edges.reduce((total, timeReg) => total + timeReg.node.minutesRegistered, 0);
												const high = task.node.estimateForecast * task.node.project.minutesPerEstimationPoint;
												overForecast = (high - time) * -1;
											}
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={Util.convertMinutesToFullHour(overForecast > 0 ? overForecast : 0, this.props.intl)}
												/>
											);
										} else if (col.name === 'over high') {
											let overForecast;
											if (task.node.project.estimationUnit === 'HOURS') {
												overForecast = (task.node.estimateHigh - task.node.timeRegistrations.edges.reduce((total, timeReg) => total + timeReg.node.minutesRegistered, 0)) * -1;
											} else {
												const time = task.node.timeRegistrations.edges.reduce((total, timeReg) => total + timeReg.node.minutesRegistered, 0);
												const high = task.node.estimateHigh * task.node.project.minutesPerEstimationPoint;
												overForecast = (high - time) * -1;
											}
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={Util.convertMinutesToFullHour(overForecast > 0 ? overForecast : 0, this.props.intl)}
												/>
											);
										} else if (col.name === 'assigned') {
											return (
												<TdLink
													key={index}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													path={this.getPath(task)}
													content={
														<AssignedTableTile
															disabled={true}
															useTableStyling={true}
															assignablePersons={[]}
															assignableRoles={[]}
															assignedRole={task.node.role}
															assignedPersons={task.node.assignedPersons}
															isMultiSelect={true}
															id={task.node.id}
															key={'assigned'}
															task={task}
															maxDisplayed={3}
															roleAssigned={task.node.role ? task.node.role.name : ''}
															cy={'assigned'}
														/>
													}
												/>
											);
										} else if (col.name === 'sprint') {
											return (
												<TdLink
													key={index}
													path={this.getPath(task)}
													content={task.node.sprint ? task.node.sprint.name : ''}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													className={task.node.sprint ? 'sprint-td' : ''}
												/>
											);
										} else if (col.name === 'labels') {
											return (
												<TdLink
													key={index}
													path={this.getPath(task)}
													content={<LabelsCell labelList={task.node.taskLabels.slice(0, 3)} labelsCount={task.node.taskLabels.length} />}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
												/>
											);
										} else if (col.name === 'milestone') {
											return (
												<TdLink
													key={index}
													path={this.getPath(task)}
													content={task.node.phase ? task.node.phase.name : formatMessage({id: 'project_scopes.no-scope'})}
													showTaskModal={this.props.showTaskModal.bind(this, task.node.companyTaskId)}
													className={task.node.phase ? ' phase-td' : ''}
												/>
											);
										} else return null;
									} else {
										return null;
									}
								})}
								<td className={'td-link-component'}>
									<StarTask task={task.node} parentId={this.props.viewerId}></StarTask>
								</td>

								<td className="last-cell">
									<div className="chip-container">
										<div className="chip-div" />
										<div className="chip" />
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	}
}
export default injectIntl(UpcomingTasksTable);
